import type { FieldError } from "react-hook-form"

import { ESessionModality, type IAttendanceSessionParticipantModel as IParticipantModel } from "@/3514/types"
import { type TEmptyAsyncCallback } from "@/shared/types/functions"

type TAttendanceModalParticipantMark = "present" | "not_present" | null

type TAttendanceModalFormRowData = {
    participantId: number
    cohortId: number | null
    isExtraParty: boolean
    attendance: TAttendanceModalParticipantMark
    focusTagId: number | null
    focusTagTitle: string | null
    focusTagResponse: string | null
    moduleId: number | null
    moduleName: string | null
    showModuleSelect: boolean
    showTagSelect: boolean
}

type TAttendanceModalFormRowErrors = {
    attendance?: FieldError
    focusTagId?: FieldError
    focusTagResponse?: FieldError
}

type TAttendanceModalForm = {
    marks: TAttendanceModalFormRowData[]
}

type TAttendanceModalParticipantRowData = IParticipantModel & { isExtraParty: boolean; role: string | null }

enum EAttendanceModalOrigin {
    CoachingSessions = "coachingSessions",
    MissedAttendances = "missedAttendances"
}

type TAttendanceModalProps =
    | {
          origin: EAttendanceModalOrigin.CoachingSessions
          onSubmitSuccess?: never
          groupId: number | null
          sessionId: number
          sessionStartTime: string
          minHoursToMark: number
          sessionModality: ESessionModality
          participantId: number
      }
    | {
          origin: EAttendanceModalOrigin.MissedAttendances
          onSubmitSuccess: TEmptyAsyncCallback
          groupId?: never
          sessionId: number
          sessionStartTime: string
          minHoursToMark?: never
          sessionModality?: never
          participantId?: never
      }

type TAttendanceEarlyModalProps = {
    advanceTimeInHours: number
}

export { EAttendanceModalOrigin }
export type {
    TAttendanceModalProps,
    TAttendanceModalParticipantMark,
    TAttendanceModalFormRowErrors,
    TAttendanceModalFormRowData,
    TAttendanceModalForm,
    TAttendanceModalParticipantRowData,
    TAttendanceEarlyModalProps
}
